import { useForm } from '@mantine/form';

import type { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

import { useCreateResponseProjectBlockMutation } from '../../../../../hooks/useCreateResponseProjectBlock.hooks';
import { useResponseProjectDetailContext } from '../../../context/responseProjectDetailContext';

interface ResponseProjectCreateBlockFormValues {
  title: string;
  description: string;
}

interface UseResponseProjectCreateBlockFromProps {
  index: number;
  parentId?: number;
  projectId: number;
  onSuccess?: () => void;
}

export function useResponseProjectCreateBlockFrom({
  index,
  parentId,
  projectId,
  onSuccess,
}: UseResponseProjectCreateBlockFromProps) {
  const { t } = useTranslation('bidResponse');
  const { openBlocks } = useResponseProjectDetailContext();
  const { mutateAsync: createBlock } =
    useCreateResponseProjectBlockMutation(projectId);

  const form = useForm<ResponseProjectCreateBlockFormValues>({
    validateInputOnChange: true,
    validate: {
      title: value => validateTitle(value, t),
    },
  });

  const handleSubmit = async (values: ResponseProjectCreateBlockFormValues) => {
    await createBlock({
      title: values.title,
      description: values.description,
      index,
      parentBlockId: parentId,
    });
    if (parentId) {
      openBlocks([parentId]);
    }
    onSuccess?.();
  };

  return { form, handleSubmit };
}

function validateTitle(value: string, t: TFunction<'bidResponse'>) {
  if (!value) {
    return t('projectDetail.createBlock.nameField.error');
  }
  return null;
}
